module.exports = __webpack_public_path__ + "img/dashboard.a3d09ce0.svg";